export default "__VITE_ASSET__CMWPT$2x__"